/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Les_Start_Api_Errors_Docent_Already_Has_Active_LesInputs */

const nl_les_start_api_errors_docent_already_has_active_les = /** @type {(inputs: Les_Start_Api_Errors_Docent_Already_Has_Active_LesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt al een actieve les. Rond die eerst af voordat je een nieuwe les start.`)
};

/**

* @param {Les_Start_Api_Errors_Docent_Already_Has_Active_LesInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const les_start_api_errors_docent_already_has_active_les = /** @type {((inputs?: Les_Start_Api_Errors_Docent_Already_Has_Active_LesInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Les_Start_Api_Errors_Docent_Already_Has_Active_LesInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_les_start_api_errors_docent_already_has_active_les(inputs)
});
export { les_start_api_errors_docent_already_has_active_les as "les.start.api_errors.docent_already_has_active_les" }